<div class="dashboard-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Dashboard.Title' | translate }}</span>
    </div>

    <div class="table-container">
        <mat-progress-bar mode="buffer" [value]="cachePercent"></mat-progress-bar>

        <div class="mat-elevation-z8">
            <table>
                <tr>
                    <td>
                        <h2>{{ 'Dashboard.Extensions' | translate }}</h2>
                    </td>
                    <td>
                        <button mat-icon-button (click)="loadExtensions()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </td>
                </tr>
            </table>

            <div>
                <apx-chart
                    #chartExtensions
                    [series]="chartExtensionsOptions.series"
                    [chart]="chartExtensionsOptions.chart"
                    [dataLabels]="chartExtensionsOptions.dataLabels"
                    [plotOptions]="chartExtensionsOptions.plotOptions"
                    [xaxis]="chartExtensionsOptions.xaxis"
                    [stroke]="chartExtensionsOptions.stroke"
                    [fill]="chartExtensionsOptions.fill"
                    [yaxis]="chartExtensionsOptions.yaxis"
                    [title]="chartExtensionsOptions.title"
                    [tooltip]="chartExtensionsOptions.tooltip"
                    [theme]="chartExtensionsOptions.theme"
                    [legend]="chartExtensionsOptions.legend"></apx-chart>
            </div>
            <table>
                <tr>
                    <td>
                        <h2>
                            {{ 'Dashboard.Calls' | translate }}
                        </h2>
                    </td>
                    <td>
                        <button mat-icon-button (click)="loadCdrs()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </td>
                </tr>
            </table>

            <div>
                <apx-chart
                    #chartCalls
                    [series]="chartCallsOptions.series"
                    [chart]="chartCallsOptions.chart"
                    [dataLabels]="chartCallsOptions.dataLabels"
                    [plotOptions]="chartCallsOptions.plotOptions"
                    [xaxis]="chartCallsOptions.xaxis"
                    [stroke]="chartCallsOptions.stroke"
                    [fill]="chartCallsOptions.fill"
                    [yaxis]="chartCallsOptions.yaxis"
                    [title]="chartCallsOptions.title"
                    [tooltip]="chartCallsOptions.tooltip"
                    [theme]="chartCallsOptions.theme"
                    [legend]="chartCallsOptions.legend"></apx-chart>
            </div>
            <table>
                <tr>
                    <td>
                        <h2 style="white-space: nowrap">
                            {{ 'Dashboard.CurrentCalls' | translate }}
                        </h2>
                    </td>
                    <td>
                        <button mat-icon-button (click)="loadCalls()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </td>
                </tr>
            </table>

            <div>
                <table id="calls" mat-table [dataSource]="calls">
                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef class="small">{{ 'Call.Time' | translate }}</th>
                        <td mat-cell *matCellDef="let call">
                            {{ call.setupTime || call.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="caller">
                        <th mat-header-cell *matHeaderCellDef class="small">{{ 'Call.Caller' | translate }}</th>
                        <td mat-cell *matCellDef="let call">
                            {{ call.from.user }}
                            @if (call.from.user!=call.from.display && call.from.display) {
                            <sup>&nbsp;({{ call.from.display }})</sup>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef class="small">{{ 'Call.State' | translate }}</th>
                        <td mat-cell *matCellDef="let call">
                            <table>
                                <tr>
                                    <td>
                                        <button mat-icon-button (click)="onReleaseCall(call.id)">
                                            <mat-icon>stop</mat-icon>
                                        </button>
                                    </td>
                                    <td>{{ 'CallStates.' + call.state | translate }}</td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="called">
                        <th mat-header-cell *matHeaderCellDef class="small">{{ 'Call.Called' | translate }}</th>
                        <td mat-cell *matCellDef="let call">
                            {{ call.to[0].user }}
                            @if (call.to[0].user!=call.to[0].display && call.to[0].display) {
                            <sup>&nbsp;({{ call.to[0].display }})</sup>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="error">
                        <th mat-header-cell *matHeaderCellDef class="small">{{ 'Call.Error' | translate }}</th>
                        <td mat-cell *matCellDef="let call">
                            @if (call.errorCode==0) {
                            <mat-icon matListItemIcon [ngStyle]="{ color: 'grey' }">volume_up</mat-icon>
                            } @if (call.errorCode>0 && call.duration>0) {
                            <mat-icon matListItemIcon [ngStyle]="{ color: 'green' }">check_circle</mat-icon>
                            } @if (call.errorCode>0 && call.duration<=0) {
                            <mat-icon matListItemIcon [ngStyle]="{ color: 'orange' }">error</mat-icon>
                            } @if (call.errorCode>0) {
                            <span>
                                {{ call.errorDescription }}&nbsp;
                                <sup>({{ call.errorCode }})</sup>
                            </span>
                            }
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
